module.exports = __webpack_public_path__ + "img/headerBaby.a0795b72.png";